export enum VehicleType {
    BICYCLE = 'bicycle',
    UNSPECIFIED = 'unspecified',
    C1 = 'C1',
    C2 = 'C2',
    C3 = 'C3',
    C4 = 'C4',
    C5 = 'C5',
    KNP = 'KNP',
    L1 = 'L1',
    L1e = 'L1e',
    L2 = 'L2',
    L2e = 'L2e',
    L3 = 'L3',
    L3e = 'L3e',
    L4 = 'L4',
    L4e = 'L4e',
    L5 = 'L5',
    L5e = 'L5e',
    L6e = 'L6e',
    L7e = 'L7e',
    LTR = 'LTR',
    M1 = 'M1',
    M1G = 'M1G',
    M2 = 'M2',
    M2G = 'M2G',
    M3 = 'M3',
    M3G = 'M3G',
    MA = 'MA',
    MTK = 'MTK',
    N1 = 'N1',
    N1G = 'N1G',
    N2 = 'N2',
    N2G = 'N2G',
    N3 = 'N3',
    N3G = 'N3G',
    O1 = 'O1',
    O2 = 'O2',
    O3 = 'O3',
    O4 = 'O4',
    Ra1 = 'Ra1',
    Ra2 = 'Ra2',
    Ra3 = 'Ra3',
    Ra4 = 'Ra4',
    Rb1 = 'Rb1',
    Rb2 = 'Rb2',
    Rb3 = 'Rb3',
    Rb4 = 'Rb4',
    Sa1 = 'Sa1',
    Sa2 = 'Sa2',
    Sb1 = 'Sb1',
    Sb2 = 'Sb2',
    T = 'T',
    T1 = 'T1',
    T2 = 'T2',
    T3 = 'T3',
    T4 = 'T4',
    T5 = 'T5',
    T1b = 'T1b',
    T2b = 'T2b',
    T3b = 'T3b',
}
